import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { keyBy, uniqBy } from 'lodash';

import './index.scss';
import CommonTable from '../../common/table';
import { REDUCER_NAME, fetchRumors, resetStoreData } from '../../reducer';
import Const from '../../Const';
import { getDataFollowKeyByDot } from '../../../helpers/Common';
import { I18n } from 'react-redux-i18n';

class Rumors extends React.Component {
  componentDidMount() {
    const { fetchRumors, resetStoreData } = this.props;
    resetStoreData('rumorsData');
    fetchRumors();
  }

  componentDidUpdate(prevProps) {
    const { fetchRumors, resetStoreData } = this.props;
    if (prevProps.i18n.locale !== this.props.i18n.locale) {
      resetStoreData('rumorsData');
      fetchRumors();
    }
  }

  transformData = (data, filterCondition) => {
    if (filterCondition.length) {
      return data.filter(item => {
        return filterCondition.includes(item[Const.RumorsTable.TRUSTABILITY]);
      });
    }

    return [];
  };

  render() {
    const {
      rumorsData: {
        data,
        isLoading,
        filterCondition,
        isShortByFavorite,
        storeName,
      },
      rumorsData,
    } = this.props;

    const filteredData = this.transformData(data, filterCondition);
    //data with condition
    const listIdsInLocalStore =
      JSON.parse(localStorage.getItem(storeName)) || [];
    //data in Local Store
    const uniqueIds = uniqBy(listIdsInLocalStore, e => {
      return e;
    });
    // make list unique

    const fakeFilteredDataID = filteredData.map((item, index) => {
      return {
        ...item,
        newsId: index + 1,
      };
    });

    const listFullData = keyBy(
      fakeFilteredDataID,
      Const.NewsAggregatorTable.ID,
    );

    const listIds = fakeFilteredDataID.map(item =>
      getDataFollowKeyByDot(item, Const.NewsAggregatorTable.ID),
    );
    const idsInCurrentList = uniqueIds.filter(id => listIds.includes(id));

    const optProps = isShortByFavorite
      ? {
          isGroupData: false,
          ids: idsInCurrentList,
        }
      : {
          ids: listIds,
        };

    return (
      <>
        <CommonTable
          isOnlyShowDate={true}
          dateTitleFormat="MMMM YYYY"
          listColumn={Const.RumorsTable}
          list={listFullData}
          isLoading={isLoading}
          isShortByFavorite={isShortByFavorite}
          type="r"
          commonData={rumorsData}
          dateKey="publicDate"
          {...optProps}
        />
        <div
          className="unit-title-note"
          style={{ marginTop: '10px', marginBottom: '10px' }}
        >
          {I18n.t('economy.listLabel.unitTitleNote1')}
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    rumorsData: state[REDUCER_NAME].rumorsData,
    i18n: state.i18n,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchRumors: () => dispatch(fetchRumors()),
    resetStoreData: storeName => dispatch(resetStoreData(storeName)),
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(Rumors);
